var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFire = function SvgFire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.296 19a4.8 4.8 0 0 1-2.723-.844 4.88 4.88 0 0 1-1.782-2.24 4.9 4.9 0 0 1-.225-2.862 4.9 4.9 0 0 1 1.41-2.495C9.843 9.737 11.973 8.256 11.65 5c3.877 2.605 5.816 5.21 1.938 9.116.647 0 1.616 0 3.231-1.608.175.503.323 1.044.323 1.608 0 1.296-.51 2.538-1.419 3.454A4.83 4.83 0 0 1 12.296 19"
  })));
};
export default SvgFire;